import request from '@/utils/request';

/** 角色列表（分页） */
export function getRoleList(params) {
  return request.get('/role/list', { params });
}

/** 全部角色（不分页，供用户管理页的角色下拉框使用） */
export function getRoleAll() {
  return request.get('/role/all');
}

/** 新增角色 */
export function createRole(data) {
  return request.post('/role/create', data);
}

/** 更新角色 */
export function updateRole(data) {
  return request.put('/role/update', data);
}

/** 删除角色 */
export function deleteRole(id) {
  return request.delete('/role/delete', { params: { id } });
}
